/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import BugReportToast from "./BugReportToast";
import {
  useInvokeBugReportModalCallback,
  usePushErrorToStackCallback,
} from "../../../store/bugReport/useActions";
import {
  BugModalInvoker,
  StandardErrorData,
} from "../../../store/bugReport/types";
import useRunOnceWhenReady from "../../../hooks/utils/useRunOnceWhenReady";

const Container: FC<Props> = ({ msg, errorStack }) => {
  const { Toast } = BugModalInvoker;
  const invokeModal = useInvokeBugReportModalCallback(Toast);
  const pushErrorToStack = usePushErrorToStackCallback(Toast);

  useRunOnceWhenReady(() => pushErrorToStack(errorStack), true);

  return (
    <BugReportToast errorMsg={msg} reportBug={() => invokeModal(errorStack)} />
  );
};

export type Props = {
  msg: string;
  errorStack: StandardErrorData | StandardErrorData[];
};

export default Container;
export type ContainerProps = Props;
